import { useTranslation } from 'react-i18next'

import { HideIcon } from '@ui/icons/Hide.icon'
import { ShowIcon } from '@ui/icons/Show.icon'

import { useLocallyPersistedState } from '@hooks/useStorage'

import { MenuSection } from '../useMenuSections'

export const useHideSensitiveData = (): MenuSection => {
  const { t } = useTranslation()
  const [hideSensitiveData, setHideSensitiveData] = useLocallyPersistedState(
    'areSensitiveDataHidden',
    false
  )

  return {
    id: 'hide-sensitive-data',
    label: hideSensitiveData ? t('Show Sensitive Data') : t('Hide Sensitive Data'),
    icon: hideSensitiveData ? HideIcon : ShowIcon,
    onClick: () => {
      setHideSensitiveData(!hideSensitiveData)
    },
  }
}
